<ng-container>
  <div class="login-auth">
    <div class="loginWrap">
      <div class="bgImg"></div>
      <div class="logoSpacer">
        <div class="loginLogoContainer">
          <div class="loginLogo">
            <app-logo></app-logo>
          </div>

          <div
            *ngIf="!requestedScope; else oauthLoading"
            class="auth-container"
          >
            <div class="basic-auth-wrapper">
              <amplify-authenticator
                hideSignUp="true"
                [formFields]="formFields"
              >
                <ng-template amplifySlot="sign-in-header">
                  <h3
                    class="amplify-heading logIn"
                    style="
                      padding: var(--amplify-space-xl) 0 0
                        var(--amplify-space-xl);
                    "
                  >
                    Welcome
                  </h3>
                  <p class="welcome-message">
                    Please enter your credentials to sign in
                  </p>
                </ng-template>
                <ng-template
                  amplifySlot="sign-in-footer"
                  style="display: contents"
                >
                  <div data-amplify-footer class="auth-sections-container">
                    <div class="basic-auth-section">
                      <button
                        amplify-button
                        (click)="authenticator.toResetPassword()"
                        fontweight="normal"
                        size="small"
                        variation="link"
                        fullwidth="true"
                        type="button"
                        data-fullwidth="true"
                        data-size="small"
                        data-variation="link"
                        class="
                          amplify-button
                          amplify-button--fullwidth
                          amplify-button--link
                          amplify-button--small
                        "
                        style="font-weight: normal"
                      >
                        Forgot Password
                      </button>
                    </div>
                  </div>
                </ng-template>
              </amplify-authenticator>
            </div>

            <div class="sso-section" *ngIf="identityProviders.length > 0">
              <hr class="sso-divider-line" />
              <div class="sso-email-container">
                <p class="sso-info-text">
                  Your organization must be enabled for single sign-on (SSO) to
                  use this option. If you are unsure if your organization is
                  enabled, please contact your Super Access Coordinator.
                </p>
                <input
                  type="email"
                  [(ngModel)]="ssoEmail"
                  (input)="onSSOEmailChange()"
                  (keyup.enter)="onSSOEmailSubmit()"
                  placeholder="Enter your work email address"
                  class="amplify-input sso-email-input"
                />
                <button
                  (click)="onSSOEmailSubmit()"
                  class="
                    amplify-button
                    amplify-button--primary
                    amplify-button--fullwidth
                    amplify-button--medium
                    sso-submit-button
                  "
                  type="button"
                  style="
                    font-weight: normal;
                    margin-top: var(--amplify-space-small);
                  "
                >
                  Login with Company Single Sign-On
                </button>
                <p class="sso-info-text">
                  If your organization is interested in being enabled for single
                  sign-on, please visit the
                  <a href="#" target="_blank" class="sso-kb-link"
                    >information available in the DC Knowledge base</a
                  >.
                </p>
              </div>
            </div>
          </div>

          <ng-template #oauthLoading>
            <div style="text-align: center; padding: 50px; color: white">
              <h3>Redirecting to OAuth...</h3>
              <p>
                Please wait while we redirect you to the authentication
                provider.
              </p>
            </div>
          </ng-template>

          <div style="display: none">
            <amplify-authenticator hideSignUp="true" [formFields]="formFields">
              <ng-template amplifySlot="setup-totp-header">
                <h3
                  class="amplify-heading totp"
                  style="
                    padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
                  "
                >
                  Setup authentication
                </h3>
                <p>Please scan the QR code with your authenticator app</p>
              </ng-template>
              <ng-template amplifySlot="confirm-sign-in-header">
                <h3
                  class="amplify-heading"
                  style="
                    padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
                  "
                >
                  Confirm authenticator code
                </h3>
                <p>
                  Please enter the six digit code from your authenticator app
                </p>
              </ng-template>
              <ng-template amplifySlot="confirm-sign-up-header">
                <h3
                  class="amplify-heading"
                  style="
                    padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
                  "
                >
                  Please set a new password
                </h3>
              </ng-template>
              <ng-template amplifySlot="sign-up-header">
                <h3
                  class="amplify-heading"
                  style="
                    padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
                  "
                >
                  Please set a new password
                </h3>
              </ng-template>
              <ng-template amplifySlot="reset-password-header">
                <h3
                  class="amplify-heading forgotPwd"
                  style="
                    padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
                  "
                >
                  Password reset
                </h3>
                <p>
                  Please enter your username and click 'Send Code' to reset your
                  password
                </p>
              </ng-template>
              <ng-template amplifySlot="confirm-reset-password-header">
                <h3
                  class="amplify-heading"
                  style="
                    padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
                  "
                >
                  Reset password
                </h3>
                <p>
                  Please enter the code sent to your registered email address
                  and set a new password
                </p>
              </ng-template>
            </amplify-authenticator>
          </div>

          <ng-template #oauthLoading>
            <div style="text-align: center; padding: 50px; color: white">
              <h3>Redirecting to OAuth...</h3>
              <p>
                Please wait while we redirect you to the authentication
                provider.
              </p>
            </div>
          </ng-template>

          <div class="footer">
            <!-- <p>
              Need help?<br />
              <a
                href="mailto:inspire@deltacapita.com?subject=Website%20Support%20Query"
                target="_blank"
                class="contact-team"
                >Get in touch</a
              >
              with our team.
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
